/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component (single invoice row/summary display)
 *   extends:   Component (@glimmer/component)
 *   template:  invoice-item.hbs
 *   args:      - (no this.args.* read in JS; see invoice-item.hbs for template-level args)
 *   uses:      session service
 *   siblings:  -
 *   tests:     ui-components-test.js, template-components-test.js
 */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class InvoiceItemComponent extends Component {
  @service session;
}
